<template>
  <section ref="seccionFechaRef" class="seccion-fecha-container">
    
    <!-- SECCIÓN FECHA -->
    <div ref="fechaContainerRef" class="fecha-container">
      
      <!-- Línea superior (Entra desde arriba) -->
      <div ref="fechaLineaSuperiorRef" class="fecha-linea-superior">
        <span class="fecha-mes-texto">NOVIEMBRE</span>
        <span class="fecha-dia-numero">14</span>
        <span class="fecha-hora-texto">6:00 PM</span>
      </div>

      <!-- Año inferior (Entra desde abajo) -->
      <div ref="fechaAnioRef" class="fecha-anio-numero">2026</div>
      
    </div>

  </section>
</template>

<script>
import { ref, onMounted } from 'vue'
import gsap from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

export default {
  name: 'SeccionFechaMusica',
  setup() {
    const seccionFechaRef = ref(null)
    const fechaLineaSuperiorRef = ref(null)
    const fechaAnioRef = ref(null)

    onMounted(() => {
      // Línea superior: Desciende con elegancia y aparece suavemente desde arriba
      gsap.from(fechaLineaSuperiorRef.value, {
        opacity: 0,
        y: -40,
        duration: 1.2,
        ease: 'power3.out',
        scrollTrigger: {
          trigger: seccionFechaRef.value,
          start: 'top 85%',
          toggleActions: 'play none none none'
        }
      })

      // Año inferior: Sube con finura y aparece suavemente desde abajo
      gsap.from(fechaAnioRef.value, {
        opacity: 0,
        y: 40,
        duration: 1.2,
        delay: 0.2, // Pequeño escalón estético para mayor sofisticación
        ease: 'power3.out',
        scrollTrigger: {
          trigger: seccionFechaRef.value,
          start: 'top 85%',
          toggleActions: 'play none none none'
        }
      })
    })

    return {
      seccionFechaRef,
      fechaLineaSuperiorRef,
      fechaAnioRef
    }
  }
}
</script>

<style scoped>
/* ==========================================
   1. CONTENEDOR GENERAL ADAPTABLE
   ========================================== */
.seccion-fecha-container {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: relative;
  background-color: #FFFFFF;
  padding: 4vh 5vw;
  margin-top: 5vh;
  box-sizing: border-box;
  overflow: hidden;
}

/* ==========================================
   2. SECCIÓN FECHA FLUIDA CON CLAMP
   ========================================== */
.fecha-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1vh;
  color: #b1aca6;
  width: 100%;
  max-width: 90vw;
  margin: 2vh auto;
}

.fecha-linea-superior {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: clamp(0.8rem, 4vw, 1.8rem);
  border-top: 2px solid #adaca9;
  border-bottom: 2px solid #adaca9;
  padding: 0.8vh 3vw;
  width: fit-content;
  box-sizing: border-box;
  will-change: transform, opacity; /* Optimización de rendimiento para GPU */
}

.fecha-mes-texto,
.fecha-hora-texto {
  font-family: 'Playfair Display', serif;
  font-size: clamp(0.85rem, 3.8vw, 1.15rem);
  font-weight: 600;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  color: #5999d2;
  white-space: nowrap;
}

.fecha-dia-numero {
  font-family: 'Playfair Display', serif;
  font-size: clamp(2.8rem, 13vw, 4.2rem);
  font-weight: 500;
  line-height: 0.9;
  color: #9b9a99;
}

.fecha-anio-numero {
  font-family: 'Playfair Display', serif;
  font-size: clamp(1.5rem, 7vw, 2.2rem);
  font-weight: 500;
  line-height: 1;
  color: #5999d2;
  letter-spacing: 0.25em;
  margin-top: 0.5vh;
  text-indent: 0.25em; /* Compensa el letter-spacing para mantener centrado perfecto */
  will-change: transform, opacity; /* Optimización de rendimiento para GPU */
}
</style>